module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.title) ? _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    staticClass: "main-tabs",
    model: {
      value: (_vm.tabContent),
      callback: function($$v) {
        _vm.tabContent = $$v
      },
      expression: "tabContent"
    }
  }, _vm._l((_vm.tabList), function(tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      staticClass: "main-tabs-pane",
      attrs: {
        "label": tab.label,
        "name": tab.name
      }
    }, [_vm._t(tab.name)], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34cfce08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab.vue
// module id = 1733
// module chunks = 1